<template>
<div class="examinResult" v-loading="pageLoading">
  <examin-header title="考试结果"></examin-header>
  <div class="examinResultMain">
      <img class="pass" :src="passImg" v-if="isPass"/>
      <img class="noPass" :src="noPassImg" v-else/>
      <div class="examinText">{{isPass ? '恭喜您，成功通过考试！' : '很抱歉，没有通过考试！'}}</div>
      <!-- <div class="btn" @click="toCert" v-if="isPass" >领取证书</div> -->
  </div>
  <div class="examinBtn" @click="toDetail">查看考试详情</div>
</div>
</template>

<script>
import ExaminHeader from '../components/ExaminHeader2.vue';
export default {
  name: "cert",
  data() {
    return {
      pageLoading: false,
      id:'',
     isPass:true,
      passImg:'https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/%E7%BC%96%E7%BB%84%204.png',
      noPassImg:'https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/5d13587fc0d95.png'
    }
  },
  components:{ExaminHeader},
  mounted() {
    this.id = this.$route.query.id
    this.isPass = this.$route.query.isPass==1 ? true : false
  },
  destroyed() {},
  computed: {
    plat() {
      return this.$store.state.plat_id
    }
  },
  methods: {
    toCert(){
      let url = 'https://service.amfababy.com/webpage/index'
      this.$router.replace({path:"./certSave?examinId="+this.$route.query.examinId})
    },
    toDetail(){
      this.$router.replace({path:"./examinResultDetail?id="+this.id+"&examinId="+this.$route.query.examinId})
    },
   
  
  },
  beforeRouteUpdate(to, from, next) {
    console.log('beforeRouteUpdate')
    // console.log(to)
    next()
  },

};
</script>

<style lang="scss" scoped>
.examinResult{
  text-align: center;
}
.examinResultMain{
  height: 763px;
  font-size: 38px;
  position: relative;
  margin-bottom: 41px;
}
.examinResultMain .pass{
   width: 524px;
   height: 290px;
   margin-top: 143px;
   margin-bottom: 21px;
}
.examinResultMain .noPass{
  width: 362px;
  height: 362px;
  margin-top: 78px;
  margin-bottom: 14px;
}
.examinResultMain .btn{
  position: absolute;
  bottom:0;
  left:50%;
  transform: translateX(-50%);
  width: 582px;
  height: 90px;
  line-height: 90px;
  border-radius: 44px;
  border: 2px solid #A7090A;
  font-size: 34px;
  color: #A7090A;
}
.examinBtn{
  color: #666666;
  font-size: 30px;
}
</style>

<style lang="scss">

</style>
